/**
 * Componente para configurar Music on Hold (MOH)
 * VigosCloud - Config System
 * 
 * Reutilizável para configurar MOH em qualquer fluxo de chamada
 */

import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import accessLocalStorage from '../../../services/accessLocalStorage';

function MohConfiguration({ 
  config = {
    moh_enabled: false,
    moh_class: ''
  },
  tenant,
  onChange,
  disabled = false,
  title = 'Music on Hold'
}) {
  const [mohClasses, setMohClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isMohEnabled = config.moh_enabled === true || config.moh_enabled === 't' || config.moh_enabled === 'true' || config.moh_enabled === 1;

  useEffect(() => {
    if (tenant && isMohEnabled) {
      fetchMohClasses(tenant);
    }
  }, [tenant, isMohEnabled]);

  const fetchMohClasses = async (tenantId) => {
    if (!tenantId) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
      
      const response = await axios.get(
        `${ipRequest}api/config/moh/tenant/${tenantId}`,
        { headers: { Authorization: token } }
      );
      
      if (response.data && Array.isArray(response.data)) {
        setMohClasses(response.data);
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        setMohClasses(response.data.data);
      } else {
        setMohClasses([]);
      }
    } catch (err) {
      console.error('❌ [MOH-CONFIG] Erro ao buscar classes MOH:', err);
      setError('Erro ao carregar classes MOH');
      setMohClasses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    if (onChange) {
      const newConfig = {
        ...config,
        [field]: value
      };
      
      // Se desabilitar MOH, limpar a classe selecionada
      if (field === 'moh_enabled' && !value) {
        newConfig.moh_class = '';
      }
      
      // Se habilitar MOH e houver tenant, carregar classes
      if (field === 'moh_enabled' && value && tenant) {
        fetchMohClasses(tenant);
      }
      
      onChange(newConfig);
    }
  };

  return (
    <div className="box" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h3 className="title is-5 mb-4">
        <FontAwesomeIcon icon={faMusic} className="mr-2" />
        {title}
      </h3>

      <div className="field">
        <label className="checkbox">
          <input
            type="checkbox"
            checked={isMohEnabled}
            onChange={(e) => handleChange('moh_enabled', e.target.checked)}
            disabled={disabled}
          />
          <span className="ml-2">
            <FontAwesomeIcon icon={faMusic} className="mr-2" />
            Habilitar Music on Hold
          </span>
        </label>
        <p className="help">
          Se habilitado, a música de espera será reproduzida durante chamadas em espera (Queue/Dial)
        </p>
      </div>

      {isMohEnabled && (
        <div className="field">
          <label className="label">Classe MOH *</label>
          <div className="control">
            <div className={`select is-fullwidth ${loading ? 'is-loading' : ''}`}>
              <select
                value={config.moh_class || ''}
                onChange={(e) => handleChange('moh_class', e.target.value)}
                disabled={disabled || loading}
              >
                <option value="">Selecione uma classe MOH</option>
                {mohClasses.map(moh => (
                  <option key={moh.name} value={moh.name}>
                    {moh.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {error && (
            <p className="help is-danger">{error}</p>
          )}
          {!error && !loading && mohClasses.length === 0 && tenant && (
            <p className="help is-warning">
              Nenhuma classe MOH encontrada para este tenant. Configure classes MOH primeiro.
            </p>
          )}
          {!tenant && (
            <p className="help is-warning">
              Selecione um tenant para carregar as classes MOH disponíveis.
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default MohConfiguration;

